import {
  DEFAULT_LINE_PLOT_SETTINGS,
  DEFAULT_X_AXIS_SETTINGS,
  xAxisLabels,
} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {
  createBooleanDisplayFn,
  createEnumDisplayFn,
  createNumberDisplayFn,
} from './linePlotDisplayFactories';

export const getXAxisDisplayRow = createEnumDisplayFn({
  field: 'xAxis',
  label: 'Value',
  groupTitle: 'X axis',
  defaultValue: DEFAULT_X_AXIS_SETTINGS.xAxis,
  formatter: value => xAxisLabels[value] ?? value,
});

export const getXLogScaleDisplayRow = createBooleanDisplayFn({
  field: 'xLogScale',
  label: 'Log scale',
  groupTitle: 'X axis',
  defaultValue: DEFAULT_LINE_PLOT_SETTINGS.xLogScale,
});

export const getXAxisMinDisplayRow = createNumberDisplayFn({
  field: 'xAxisMin',
  label: 'Min',
  groupTitle: 'X axis',
});

export const getXAxisMaxDisplayRow = createNumberDisplayFn({
  field: 'xAxisMax',
  label: 'Max',
  groupTitle: 'X axis',
});

export const getXAxisFormatDisplayRow = createEnumDisplayFn({
  field: 'xAxisFormat',
  label: 'Format',
  groupTitle: 'X axis',
});
